import React from 'react';
import { Link } from 'react-router-dom';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import './ArticleNavigation.css';

/**
 * ArticleNavigation Component
 * Navigation cards for Previous/Next articles
 * Used in both Help Center and API Documentation
 */
const ArticleNavigation = ({ previous, next }) => {
  return (
    <div className="article-navigation">
      {previous ? (
        <Link to={previous.route} className="article-nav-card article-nav-prev">
          <CaretLeft weight="regular" size={16} className="article-nav-icon" />
          <div className="article-nav-content">
            <span className="article-nav-label">Previous</span>
            <span className="article-nav-title">{previous.title}</span>
          </div>
        </Link>
      ) : (
        <div className="article-nav-card article-nav-prev article-nav-disabled">
          <CaretLeft weight="regular" size={16} className="article-nav-icon" />
          <div className="article-nav-content">
            <span className="article-nav-label">Previous</span>
            <span className="article-nav-title">—</span>
          </div>
        </div>
      )}
      {next ? (
        <Link to={next.route} className="article-nav-card article-nav-next">
          <CaretRight weight="regular" size={16} className="article-nav-icon" />

          <div className="article-nav-content">
            <span className="article-nav-label">Next</span>
            <span className="article-nav-title">{next.title}</span>
          </div>
        </Link>
      ) : (
        <div className="article-nav-card article-nav-next article-nav-disabled">
          <CaretRight weight="regular" size={16} className="article-nav-icon" />

          <div className="article-nav-content">
            <span className="article-nav-label">Next</span>
            <span className="article-nav-title">—</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticleNavigation;
